import React from 'react';
import { Translate } from 'react-redux-i18n';

class HeaderUserInfo extends React.Component {
  closePopup = () => {
    const { handleClickOutside } = this.props;
    handleClickOutside();
  };
  render() {
    return (
      <div className="header-user-info">
        <div
          style={{
            width: 20,
            height: 20,
            marginLeft: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <i className="icon-user fs-16" />
        </div>
        <Translate value={`systemSetting.userInfo.title`} />
        <a href="#" onClick={this.closePopup}>
          <i className="icon-close text-stock-chart" />
        </a>
      </div>
    );
  }
}

export default HeaderUserInfo;
